import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import styles from './style.module.scss';

const FAQ = ({ data, onEdit, style, onChange }) => {
    return (
        <ModuleBase onEdit={onEdit} style={style} onChange={onChange}>
            <div className={styles.faq}>
                {data?.items?.map((item, index) => (
                    <div key={index} className={styles.faqItem}>
                        <div className={styles.question}>
                            <span className={styles.questionMark}>Q:</span>
                            <span className={styles.questionText}>{item.question}</span>
                        </div>
                        <div className={styles.answer}>
                            <span className={styles.answerMark}>A:</span>
                            <span className={styles.answerText}>{item.answer}</span>
                        </div>
                    </div>
                )) || (
                        <div className={styles.empty}>暂无常见问题</div>
                    )}
            </div>
        </ModuleBase>
    );
};

export default FAQ;